import { requestInFlight, requestSuccess, requestError } from '..';
import { Dispatch } from 'redux';
import * as AssignmentApi from 'api/assignment';
import { AppStoreState } from 'types';
import { batch } from 'react-redux';
import { fetchLessonPlan } from './lesson-planner';

export const createUserAssignment = assignments => {
  return async (dispatch: Dispatch) => {
    dispatch(requestInFlight());
    try {
      const { data } = await AssignmentApi.createAssignment(assignments);
      return await dispatch(requestSuccess({ assignments: data }));
    } catch (err) {
      dispatch(requestSuccess({}));
    }
  };
};

export const saveUserAssignment = (assignmentId, updates, params?) => {
  return async (dispatch: Dispatch, getState: () => AppStoreState) => {
    dispatch(requestInFlight());
    try {
      const { data } = await AssignmentApi.saveAssignment(assignmentId, { data: updates, params });

      const {
        entity: { assignments }
      } = getState();

      return await dispatch(
        requestSuccess({
          assignments: [...assignments.filter(({ id }) => id !== data.id), data]
        })
      );
    } catch (err) {
      return await dispatch(requestSuccess({}));
    }
  };
};

export const createUserAssignmentInstructions = (assignmentId, file) => {
  return async (dispatch: Dispatch) => {
    dispatch(requestInFlight());

    try {
      await AssignmentApi.createAssignmentInstructions(assignmentId, file);

      return await dispatch(requestSuccess({}));
    } catch (err) {
      dispatch(requestSuccess({}));
    }
  };
};

export const getAssignments = (filter?: any) => {
  return async (dispatch: Dispatch, getState: () => AppStoreState) => {
    dispatch(requestInFlight());
    const {
      app: { currentWorkbook }
    }: any = getState();

    const productCurriculumId = currentWorkbook?.products[0].productCurriculumId;

    try {
      const { data: assignments } = await AssignmentApi.getUserAssignments(
        productCurriculumId,
        filter
      );
      return dispatch(requestSuccess({ assignments }));
    } catch (err) {
      dispatch(requestError(err));
    }
  };
};

export const getAssignment = (assignmentId: number, params?: any) => {
  return async (dispatch: Dispatch) => {
    dispatch(requestInFlight());

    try {
      const { data: assignmentDetail } = await AssignmentApi.getUserAssignment(
        assignmentId,
        params
      );

      return dispatch(requestSuccess({ assignmentDetail }));
    } catch (err) {
      dispatch(requestError(err));
    }
  };
};

export const getUserAssignmentsView = (classroomId?) => {
  return async (dispatch: Dispatch, getState) => {
    dispatch(requestInFlight());

    const {
      app: { currentWorkbook, selectedClassroomId }
    }: AppStoreState = getState();

    const [{ productCurriculumId }]: any = currentWorkbook?.products ?? [];

    const params = {
      classroomIds: classroomId || selectedClassroomId,
      displayBy: 'dateDue'
    };

    try {
      const { data: userAssignments } = await AssignmentApi.fetchUserAssignmentsView(
        productCurriculumId,
        params
      );

      return dispatch(requestSuccess({ userAssignments }));
    } catch (err) {
      dispatch(requestSuccess({}));
    }
  };
};

export const deleteUserAssignment = (assignmentId: number, params?) => {
  return async (dispatch: Dispatch) => {
    dispatch(requestInFlight());

    try {
      await AssignmentApi.deleteUserAssignment(assignmentId, params);

      batch(() => {
        dispatch(getUserAssignmentsView() as any);
        dispatch(fetchLessonPlan() as any);
        return dispatch(requestSuccess({ deletedAssignment: assignmentId }));
      });
    } catch (err) {
      return dispatch(requestSuccess({}));
    }
  };
};

export const deleteUserAssignmentInstructions = (assignmentId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch(requestInFlight());

    try {
      await AssignmentApi.deleteUserAssignmentInstructions(assignmentId);

      batch(() => {
        dispatch(getUserAssignmentsView() as any);
        return dispatch(requestSuccess({ deletedAssignmentInstructions: assignmentId }));
      });
    } catch (err) {
      dispatch(requestSuccess({}));
    }
  };
};
